import React from 'react'
import { useQuery } from 'react-query';
import { exams } from '../../../api/exams';
import Loader from '../../../components/loader/Loader';
import { Link } from 'react-router-dom';

const ViewResponse = () => {

   const activeSurvey = JSON.parse(sessionStorage.getItem('activeSurvey') || '{}')
    const {
      isLoading,
      data: response,
      refetch,
    } = useQuery(
      ["user-group-assessment", ],
      async () => {
        const data = await exams.getSurveyResponse({
          userId: activeSurvey?.user_id,
          userExamId: activeSurvey?.user_exam_id
        })
        return data;
      },
      {
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        select: res => res?.data
      }
    );

  if(isLoading) return <Loader />

  return (
    <div className=''>
      <header className='flex justify-between items-center mb-3'>
        <h1 className='text-2xl font-semibold '>
          {activeSurvey?.group_title}
        </h1>
        <Link to={'/candidate/my-review'} className='text-lg bg-darkBlue text-white py-2 px-12 rounded-xl rounded'>
           Back
        </Link>
      </header>
       <header className='grid  grid-cols-1 gap-5 md:grid-cols-3'>
           <div className='bg-white p-3 py-12 rounded-lg'>
              <h2 className='text-lg text-center font-semibold'>
                  Participant
              </h2>
              <p className='text-md text-center'>
                {activeSurvey?.user_name}
              </p>
           </div>
           <div className='bg-white p-3 py-12 rounded-lg'>
              <h2 className='text-lg text-center font-semibold'>
                  Started At
              </h2>
              <p className='text-md text-center'>
                {`${ new Date(response?.userExam?.startedAt).toLocaleDateString('en-ng')}`}
              </p>
           </div>
           <div className='bg-white p-3 py-12 rounded-lg'>
              <h2 className='text-lg text-center font-semibold'>
                  Completed At
              </h2>
              <p className='text-md text-center'>
                {`${ new Date(response?.userExam?.completedAt).toLocaleDateString('en-ng')}`}
              </p>
           </div>
       </header>
       <h5 className='mt-5 text-xl'>
         Reviewers
       </h5>
       <header className='grid  grid-cols-1 mt-5 gap-5 md:grid-cols-2'>
          {
            response?.reviewers?.map((r: any, i: number) => (
               
                <div className='bg-white p-3 py-12 rounded-lg'>
                   <h2 className='text-lg text-center font-semibold'>
                      Name: {r?.name}
                   </h2>
                   <p className='text-md text-center'>
                     Email: {r?.email}
                   </p>
                </div>
              
            ))
          }
       </header>
       <h5 className='mt-5 text-xl'>
          Question & Responses
       </h5>
       <header className='grid  grid-cols-1 mt-5 gap-5'>
          {
            response?.questions?.map((q: any, i: number) => (
               
                <div className='bg-white p-3 py-5 rounded-lg'>
                   <h2 className='text-lg font-semibold'>
                      ({i + 1}) {q?.questionText}
                   </h2>
                    <h5 className='text-lg mt-3'>
                        Participant:
                    </h5>
                    <div className='mt-2 p-3 rounded-lg border border-l-2 border-l-orange-500'>
                       <p className='text-md'>Answer: {q?.participantAnswer?.answer}  </p>
                       <p className='text-md'>Rating: {q?.participantAnswer?.rating}</p>
                    </div>
                    <h5 className='text-lg mt-3'>
                        Reviewers:
                    </h5>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-5 mt-2'>
                         {
                           q?.reviewerAnswers?.map((r: any, i: number) => (
                               <div className='mt-2 p-3 rounded-lg border border-l-2 border-l-primary'>
                               <p className='text-md'>Name: {r?.reviewerName || '-'}  </p>
                                <p className='text-md'>Email: {r?.reviewerEmail || '-'}</p>
                                <p className='text-md'>Answer: {r?.answer || '-'}  </p>
                                <p className='text-md'>Rating: {r?.rating || '-'}</p>
                              </div>
                           ))
                         }
                    </div>
                </div>
              
            ))
          }
       </header>
    </div>
  )
}

export default ViewResponse